export default __webpack_public_path__ + "34272a63b841a20186b7d63935793401.png";